export const combineStyles = (defaultStyles, styles) => {
  if (!styles) return defaultStyles

  return Object.keys({ ...defaultStyles, ...styles })
    .reduce((acc, key, idx) => {
      const style = defaultStyles[key]
      const newStyle = styles[key]

      const names = []
      if (style) names.push(style)
      if (newStyle) names.push(newStyle)

      acc[key] = names.join(' ')
      return acc
    }, {})
}

